import React from 'react';

import Routes from './routes';

import './styles/global.css';

function App() {
  return (
    <Routes />
  );
}

export default App;
